import React from 'react'
import classNames from 'classnames'
import { ErrorMessage } from '../error_message'
import { FormCheckboxProps } from './types'
import { FormValues } from 'donate/types'

export const FormCheckbox = ({ field, form, ...props }: FormCheckboxProps): JSX.Element => {
  const groupClass = `donate-form-group-${field.name.replace('_', '-')}`
  const inputProps = field as HTMLProps<HTMLInputElement, typeof props>
  return (
    <div className={classNames(props.className, groupClass)}>
      <label className="generic-custom-radio-field" htmlFor={field.name}>
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
        <input type="checkbox" {...inputProps} id={field.name} defaultChecked={form.initialValues[field.name]} />
        <span className="generic-custom-radio" />
        <div>{props.label}</div>
      </label>
      <ErrorMessage field={field.name as keyof FormValues} />
    </div>
  )
}
